import React from "react";
import { Card, Checkbox, Form, InputNumber } from 'antd';
import { updateChecklist } from "../../api/checklists";
import { normalizeChecklistVisualSettings } from "../../utils/checklistVisualSettings";

const VisualSettings = ({ editingChecklist, setEditingChecklist, checklists, setChecklists, selectedStatus }) => {
  const visualSettings = normalizeChecklistVisualSettings(
    editingChecklist.visual_settings
  );

  return (
    <Card title="Визуальные настройки" size="small" style={{ marginBottom: 16 }}>
      <Form.Item 
        label="Количество выбранных кастомных полей для 100% заполнения" 
        tooltip="Укажите количество полей, при котором чеклист будет считаться полностью заполненным (100%). Если не указано, будут учитываться все поля."
      >
        <InputNumber
          min={1}
          max={editingChecklist.custom_fields.length}
          value={visualSettings.count_of_cfs_full}
          onChange={(value) => {
            const updatedSettings = normalizeChecklistVisualSettings({
              ...visualSettings,
              count_of_cfs_full: value
            });
            
            setEditingChecklist({
              ...editingChecklist,
              visual_settings: updatedSettings
            });
            
            const updatedChecklist = {
              ...editingChecklist,
              visual_settings: updatedSettings
            };
            
            setChecklists(checklists.map(c => c.id === editingChecklist.id ? updatedChecklist : c));
            updateChecklist(selectedStatus.amo_status_id, editingChecklist.id, updatedChecklist);
          }}
          placeholder="Введите количество полей"
        />
      </Form.Item>

      <Form.Item
        label="Сворачивать чеклист по умолчанию"
        tooltip="Если включено, чеклист будет свёрнут при первом открытии карточки сделки."
      >
        <Checkbox
          checked={visualSettings.collapsed_by_default}
          onChange={(e) => {
            const updatedSettings = normalizeChecklistVisualSettings({
              ...visualSettings,
              collapsed_by_default: e.target.checked,
            });

            setEditingChecklist({
              ...editingChecklist,
              visual_settings: updatedSettings,
            });

            const updatedChecklist = {
              ...editingChecklist,
              visual_settings: updatedSettings,
            };

            setChecklists(checklists.map(c => c.id === editingChecklist.id ? updatedChecklist : c));
            updateChecklist(selectedStatus.amo_status_id, editingChecklist.id, updatedChecklist);
          }}
        />
      </Form.Item>
    </Card>
  );
};

export default VisualSettings;
